var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "直播间加热",
        width: "949px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "hotlive overflowOuto",
        },
        [
          _c(
            "div",
            { staticClass: "heatType" },
            _vm._l(_vm.heatTypeOption, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "heatTypeView",
                  class: { active: _vm.form.heatType === item.value },
                  on: {
                    click: function ($event) {
                      return _vm.onhandleTypeChange(item)
                    },
                  },
                },
                [
                  item.value === 1
                    ? _c("div", { staticClass: "ifHeatIng" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              {
                                0: "未加热",
                                1: "未开始",
                                2: "加热中",
                                3: "加热结束",
                              }[_vm.ifHeatIng || 0]
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.form.heatType === item.value
                    ? _c("img", {
                        staticClass: "gouxuan",
                        attrs: {
                          src: require("@/assets/image/live/gouxuan.png"),
                        },
                      })
                    : _vm._e(),
                  _c("svg-icon", {
                    attrs: {
                      "class-name": "size-icon",
                      "icon-class": item.icon,
                    },
                  }),
                  _vm._v(" " + _vm._s(item.label) + " "),
                ],
                1
              )
            }),
            0
          ),
          _c("div", { staticClass: "hotMsg" }, [
            _c("div", { staticClass: "hotMsgTitle" }, [_vm._v("加热说明")]),
            _c("div", { staticClass: "tips" }, [
              _vm._v(
                " 当直播间开启加热后，系统将自动在我们平台的终端上展示对应的直播间广告，直播间将根据加热时长进行定时推广 ，实际加热效果受到直播间内容质量、投放时间等因素影响，预计提升观众数和下单数仅供参考，不作为加热效果的保证。 "
              ),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "m-t-20",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _vm.form.heatType === 2
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "m-b-10",
                      attrs: { label: "直播间商品", prop: "goodsId" },
                    },
                    [
                      !_vm.form.goodsId
                        ? _c(
                            "div",
                            {
                              staticClass: "goodsView",
                              on: { click: _vm.selectGoods },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" 选择加热商品 "),
                            ]
                          )
                        : _c("div", { staticClass: "goodsViewSetting" }, [
                            _c(
                              "div",
                              { staticClass: "goods-info-wrapper" },
                              [
                                _c("ImagePreviewer", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                  },
                                  attrs: {
                                    src: _vm.form.goodsImg,
                                    fit: "contain",
                                    "preview-src-list": [_vm.form.goodsImg],
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "goods-info-detail" },
                                  [
                                    _c("div", { staticClass: "titleOptions" }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.form.goodsName) + " "
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "goods-info-Price" },
                                      [
                                        _c("unitPrice", {
                                          attrs: {
                                            price: _vm.form.goodsPromotionPrice,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm.form.heatType === 2
                                  ? _c(
                                      "div",
                                      { staticClass: "maskdShow" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass:
                                              "maskdShowText maskdAginText",
                                            attrs: { type: "text" },
                                            on: { click: _vm.selectGoods },
                                          },
                                          [_vm._v("重新选择")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "m-l-20 goodsSendSetting" },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.showQuotaRadio,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "showQuotaRadio",
                                          $$v
                                        )
                                      },
                                      expression: "form.showQuotaRadio",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "showQuotaRadio-container",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "showQuotaRadio-item",
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: -1 } },
                                              [
                                                _vm._v(
                                                  "不限名额，学员端不展示名额"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "showQuotaRadio-itemcenter",
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 1 } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "line-height": "32px",
                                                    },
                                                  },
                                                  [_vm._v("限名额 ")]
                                                ),
                                                _c(
                                                  "el-input",
                                                  {
                                                    staticStyle: {
                                                      width: "152px",
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        "最大输入999",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      focus: () => {
                                                        _vm.form.showQuotaRadio = 1
                                                      },
                                                      input: function ($event) {
                                                        return _vm.delShowQuotaNumber(
                                                          $event,
                                                          _vm.form
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.showQuotaVal,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "showQuotaVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.showQuotaVal",
                                                    },
                                                  },
                                                  [
                                                    _c("el-button", {
                                                      attrs: {
                                                        slot: "append",
                                                        icon: "el-icon-minus",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          ;(_vm.form.showQuotaRadio = 1),
                                                            _vm.form
                                                              .showQuotaVal >
                                                              1 &&
                                                              _vm.form
                                                                .showQuotaVal--
                                                        },
                                                      },
                                                      slot: "append",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "line-height": "32px",
                                                    },
                                                  },
                                                  [_vm._v(" 个")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "showQuotaRadio-item",
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 0 } },
                                              [_vm._v("已抢光，学员端不能购买")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "share",
                              rawName: "v-share",
                              value: `/pages/courseDetails/${
                                _vm.form.goodsType === 8 ? "live" : "online"
                              }/index?id=${_vm.form.goodsId}&shopId=${
                                _vm.organizationId
                              }&liveId=${_vm.liveRoomId}&shareUser=${
                                _vm.shareUser
                              }&active=1`,
                              expression:
                                "\n            `/pages/courseDetails/${\n              form.goodsType === 8 ? 'live' : 'online'\n            }/index?id=${\n              form.goodsId\n            }&shopId=${organizationId}&liveId=${liveRoomId}&shareUser=${shareUser}&active=1`\n          ",
                            },
                          ],
                          staticClass: "share-link",
                          attrs: { type: "text" },
                        },
                        [_vm._v("分享链接")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.heatType === 3
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "选择加热优惠券", prop: "liveCouponId" },
                    },
                    [
                      !_vm.form.liveCouponId
                        ? _c(
                            "div",
                            {
                              staticClass: "goodsView",
                              on: { click: _vm.selectLiveCoupon },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" 选择加热优惠券 "),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "goods-info-wrapper",
                              staticStyle: { width: "234px" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "liveRoomPop-container" },
                                [
                                  _c("img", {
                                    staticClass: "liveRoomPop-img",
                                    attrs: {
                                      fit: "contain",
                                      src: require("@/assets/image/live/coupon_icon.png"),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "liveRoomPop-contant" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "liveRoomPop-title text_hidden_1",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.form.coupon.couponName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.form.coupon.discountMethod === 1
                                        ? [
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "mini" } },
                                              [_vm._v("满减券")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "coupons-content",
                                              },
                                              [
                                                _vm._v(
                                                  " 满" +
                                                    _vm._s(
                                                      _vm._f(
                                                        "filtersMoneyByZero"
                                                      )(
                                                        _vm.form.coupon
                                                          .satisfiedAmount
                                                      )
                                                    ) +
                                                    "元减" +
                                                    _vm._s(
                                                      _vm._f(
                                                        "filtersMoneyByZero"
                                                      )(
                                                        _vm.form.coupon
                                                          .subtractAmount
                                                      )
                                                    ) +
                                                    "元 "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.form.coupon.discountMethod === 2
                                        ? [
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "mini" } },
                                              [_vm._v("直减券")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "coupons-content",
                                              },
                                              [
                                                _vm._v(
                                                  " 购买立减" +
                                                    _vm._s(
                                                      _vm._f(
                                                        "filtersMoneyByZero"
                                                      )(
                                                        _vm.form.coupon
                                                          .directReductionAmount
                                                      )
                                                    ) +
                                                    "元 "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.form.coupon.discountMethod === 3
                                        ? [
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "mini" } },
                                              [_vm._v("折扣券")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "coupons-content m-l-10",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.form.coupon.sale) +
                                                    "折"
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "maskdShow" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "maskdShowText maskdAginText",
                                      attrs: { type: "text" },
                                      on: { click: _vm.selectLiveCoupon },
                                    },
                                    [_vm._v("重新选择")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                    ]
                  )
                : _vm._e(),
              _vm.form.heatType !== 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "展示停留时间", prop: "heatDuration" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "120px" },
                          attrs: { size: "small" },
                          on: { input: _vm.delNumber },
                          model: {
                            value: _vm.form.heatDuration,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "heatDuration", $$v)
                            },
                            expression: "form.heatDuration",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "append", size: "small" },
                              slot: "append",
                            },
                            [_vm._v("分钟")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.heatType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "加热时长", prop: "hotTime" } },
                    [
                      _vm.liveRoomDetail.status === 0
                        ? _c("el-date-picker", {
                            staticStyle: {
                              width: "150px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions,
                              type: "date",
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.form.hotStartDay,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hotStartDay", $$v)
                              },
                              expression: "form.hotStartDay",
                            },
                          })
                        : _vm._e(),
                      _vm.liveRoomDetail.status === 0
                        ? _c("el-time-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              "value-format": "HH:mm:ss",
                              placeholder: "选择时间",
                            },
                            model: {
                              value: _vm.form.hotStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hotStartTime", $$v)
                              },
                              expression: "form.hotStartTime",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "130px",
                            "margin-right": "10px",
                          },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.hotTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "hotTime", $$v)
                            },
                            expression: "form.hotTime",
                          },
                        },
                        _vm._l(_vm.timeoptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "hotBox" }, [
            _c("div", { staticClass: "hotBoxTitle" }, [
              _vm._v(" " + _vm._s(_vm.typeOption[_vm.form.heatType])),
              _c("span", { staticClass: "tips m-l-10" }, [
                _vm._v("预计提升观众数及投放时长仅供参考"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "upSection_box" },
              _vm._l(_vm.upSectionOption, function (item) {
                return _c(
                  "div",
                  {
                    key: item.value,
                    staticClass: "hotBoxItem",
                    class: {
                      active: item.value === _vm.form.upSection,
                      disabledClick: _vm.form.heatType === 1,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onhandleSelect(item)
                      },
                    },
                  },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "class-name": "bg-fff",
                        "icon-class": _vm.icons[_vm.form.heatType],
                      },
                    }),
                    _c("div", { staticClass: "hotBoxItem_content" }, [
                      _c("div", { staticClass: "hotBoxItem_title" }, [
                        _vm._v(
                          " " + _vm._s(_vm.typeOption[_vm.form.heatType]) + " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "hotBoxItem_title_Number" },
                        [
                          _vm.form.heatType !== 3
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getOptionsValueByKey(
                                        "value",
                                        {
                                          1: "label",
                                          2: "label2",
                                          3: "label3",
                                        }[_vm.form.heatType],
                                        item.value,
                                        _vm.upSectionOption
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                          _vm.form.heatType === 3
                            ? _c(
                                "div",
                                { staticClass: "hotBoxItem_title_Number_time" },
                                [_vm._v(" " + _vm._s(item.tips) + " ")]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "tips hotBoxItem_title_tips" }, [
                        _vm._v(" 系统智能推荐给潜在用户 "),
                      ]),
                    ]),
                    item.value === _vm.form.upSection
                      ? _c("img", {
                          staticClass: "gouxuan",
                          attrs: {
                            src: require("@/assets/image/live/gouxuan.png"),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }